import React, { Component } from 'react';
import './listItems.css';

import ProfilePic from '../../atoms/profilePic/profilePic';
import { Toggle } from '../../atoms/formElements/formElements';

export const ListIcon = ({ employee, number }) => (
  <div className='listItemWrapper' >
    <p className={`number number-${number}`}>{number}</p>
    <ProfilePic size='small' clickable='true' employee={employee} />
    <p className='name'>{employee.nameF} {employee.nameL}</p>
    <p>{employee.points}</p>
  </div>
)

export const Mention = (props) => {
  const {
    mention,
    theme,
    searchValue, // eslint-disable-line no-unused-vars
    isFocused, // eslint-disable-line no-unused-vars
    ...parentProps
  } = props;

  return (
    <div {...parentProps} className='listItemWrapper dropdown'  >
      <ProfilePic size='small' clickable='true' employee={mention} />
      <p className='name'>{mention.name}</p>
    </div>
  );
};

export const ListCommunication = ({ sender, highFive }) => (
  <div className={highFive.read ? 'listItemWrapper read' : 'listItemWrapper unread'} >
    <ProfilePic size='medium' clickable='true' employee={sender} />
    <div>
      <p className='name' >{sender ? sender.nameF + ' ' + sender.nameL : 'Account not in use'}</p>
      <p className='message' >{highFive.message}</p>
    </div>
  </div>
)

export const ListEmployees = ({ employee, onClick }) => (
  <div className={employee.enabled ? 'listItemWrapper' : 'listItemWrapper inactive'} >
    <ProfilePic size='small' clickable='false' employee={employee} />
    <div className='listName'><p className='name'>{employee.nameF} <strong>{employee.nameL}</strong></p></div>
    <span className="toggle" onClick={onClick}>
      <div className={employee.enabled ? 'input active' : 'input'} />
      <span className="slider"></span>
    </span>
  </div>
)

export const ListInvites = ({ employee, onClick }) => (
  <div className='listItemWrapper' >
    <ProfilePic size='small' clickable='false' employee={employee} />
    <div className='listName'><p className='name'>{employee.email} </p></div>
    <p className='helper'>Invite pending...</p>
  </div>
)

export const ListComments = ({ comment }) => (
  <div className='listItemWrapper' >
    <div>
      <p className='date' >{comment.date}</p>
      <p >{comment.comment}</p>
    </div>
  </div>
)
